import Head from 'next/head';
import React from 'react';

import { TFAQItem } from './types';

type TFAQsStructuredDataProps = {
  items: TFAQItem[];
};

export const FAQsStructuredData = ({ items }: TFAQsStructuredDataProps) => {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: items.map(({ question, answer }) => ({
              '@type': 'Question',
              name: question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: answer,
              },
            })),
          }),
        }}
      />
    </Head>
  );
};
